import Icons, { IconsProps } from '../../Icons';

export type ThreeSixtyProps = IconsProps;

export function ThreeSixty(props: ThreeSixtyProps) {
  return (
    <Icons {...props}>
      <path d="M8.55 17.3625L7.825 16.6625L9.975 14.5125C8.025 14.2625 6.375 13.7792 5.025 13.0625C3.675 12.3458 3 11.5375 3 10.6375C3 9.55418 3.87067 8.61685 5.612 7.82551C7.354 7.03351 9.48333 6.63751 12 6.63751C14.5167 6.63751 16.6457 7.03351 18.387 7.82551C20.129 8.61685 21 9.55418 21 10.6375C21 11.3708 20.546 12.0625 19.638 12.7125C18.7293 13.3625 17.5167 13.8542 16 14.1875V13.1875C17.2833 12.8542 18.2707 12.4415 18.962 11.9495C19.654 11.4582 20 11.0208 20 10.6375C20 10.0708 19.2877 9.42918 17.863 8.71251C16.4377 7.99585 14.4833 7.63751 12 7.63751C9.51667 7.63751 7.56267 7.99585 6.138 8.71251C4.71267 9.42918 4 10.0708 4 10.6375C4 11.1208 4.554 11.6542 5.662 12.2375C6.77067 12.8208 8.16667 13.2375 9.85 13.4875L7.825 11.4625L8.55 10.7625L11.85 14.0625L8.55 17.3625Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
